export function getHost(): string {
  switch (process.env.REACT_APP_STAGE) {
    case 'production':
      return 'https://minhaconta.oya.care/';
    case 'staging':
      return 'https://minha-conta-qa.oya.care/';
    default:
      return 'http://localhost:3001/';
  }
}
